import { Icon } from "@dmm-com/rocket-web-ui-library";
import * as Styles from "./style";

type ArrowProps = {
  isOpen: boolean;
};

export const RotateArrow = ({ isOpen }: ArrowProps) => {
  return (
    <Styles.DivArrowWrapper isOpen={isOpen}>
      <Icon name="arrowDown" size="M" color="GRAY500" />
    </Styles.DivArrowWrapper>
  );
};
